export default "__VITE_ASSET__BIlx$DNo__"